const menuStyle = {
  main: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    height: "100%",
    backgroundColor: "#333333"
  },
  item: {
    color: "#fff"
  }
};

export default menuStyle;



// WEBPACK FOOTER //
// ./src/components/Menu/style.js